<!-- <mat-form-field class="width100">
  <input matInput [formControl]="inputControl" placeholder="{{ placeholder }}" [matAutocomplete]="auto"
    (input)="filterItems($event.target.value)" [required]="isRequired">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option selected disabled value="undefined">
      <em>Seleccionar</em>
    </mat-option>
    <mat-option *ngFor="let item of filteredItems; trackBy: trackByIndex" [value]="getItemId(item)" (click)="onItemSelected(getItemId(item))">
      {{ getItemName(item) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field> -->